<template>
    <span class="meta" :class="[textSizeString, textColorString]" :style="{color: colorHex}"><slot/></span>
</template>

<script>
import TextColorable from "../../mixins/TextColorable";
    import TextSizeable from "../../mixins/TextSizeable";

    export default {
        name: "MetaText",

        mixins: [TextSizeable, TextColorable]
    }
</script>

<style>
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.meta {
  color: #5e6b6b;
  white-space: nowrap;
  font-family: "proxima-nova", "Trebuchet MS", Helvetica, sans-serif;
}
.meta:not(:last-child):after {
  content: "|";
  color: #5e6b6b !important;
  margin: 0 4px;
}
.meta:last-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>